<template>
  <section class="section section-components pb-0" id="section-components">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-12">
          <!-- Colors -->
          <h2 class="mb-5">
            <span>Colors</span>
          </h2>
          <div>
            <span class="blue-100">blue-100</span>
            <span class="blue-200 ml-3">blue-200</span>
            <span class="blue-300 ml-3">blue-300</span>
            <span class="blue-400 ml-3">blue-400</span>
            <span class="blue-500 ml-3">blue-500</span>
            <span class="blue-600 ml-3">blue-600</span>
            <span class="blue-700 ml-3">blue-700</span>
            <span class="blue-800 ml-3">blue-800</span>
            <span class="blue-900 ml-3">blue-900</span>
          </div>
          <div>
            <span class="red-100">red-100</span>
            <span class="red-200 ml-3">red-200</span>
            <span class="red-300 ml-3">red-300</span>
            <span class="red-400 ml-3">red-400</span>
            <span class="red-500 ml-3">red-500</span>
            <span class="red-600 ml-3">red-600</span>
            <span class="red-700 ml-3">red-700</span>
            <span class="red-800 ml-3">red-800</span>
            <span class="red-900 ml-3">red-900</span>
          </div>
          <div>
            <span class="gray-100">gray-100</span>
            <span class="gray-200 ml-3">gray-200</span>
            <span class="gray-300 ml-3">gray-300</span>
            <span class="gray-400 ml-3">gray-400</span>
            <span class="gray-500 ml-3">gray-500</span>
            <span class="gray-600 ml-3">gray-600</span>
            <span class="gray-700 ml-3">gray-700</span>
            <span class="gray-800 ml-3">gray-800</span>
            <span class="gray-900 ml-3">gray-900</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {};
</script>